/*======================================================================
SOLIÈRE MATCH — controlador compartido (Home + PDP)

Responsabilidades, sin duplicar entre Home y PDP:

1. bindSoliereMatch(root) — cablea el toggle "Continuar descubriendo"
   (segunda capa) y las flechas del track horizontal en CUALQUIER
   instancia de [data-soliere-match], exista ya en el HTML (PDP,
   primer render del servidor) o se acabe de inyectar (Home, tras un
   fetch).

2. initSoliereMatchHome(section) — SOLO en secciones con
   [data-soliere-match-home] (el Home). Escucha el evento
   'soliere-match:select' que dispara soliere-match-picker.js,
   pide el fragmento renderizado vía Section Rendering API
   (/products/{handle}?section_id=soliere-match-render) e inyecta el
   HTML devuelto tal cual — nunca reconstruye afinidad/razón en JS,
   eso ya viene resuelto desde Liquid contra custom.soliere_match_data.

No depende de discover-essence-engine ni de su motor de lenguaje —
solo del evento de selección que expone el picker.

Version 3.0 — FINAL VISUAL REFINEMENT: un solo track horizontal
(excepcionales + secundarias juntas); "Continuar descubriendo" ya no
oculta/muestra un bloque separado, agrega/quita .is-expanded en el
propio track (assets/maison-match.css decide qué cards se ven) y
alterna el copy del botón a "Mostrar menos". No toca el fetch, el
evento de selección ni la resolución de custom.soliere_match_data.
======================================================================*/

const MS_MORE_LABEL_COLLAPSED = "Continuar descubriendo";
const MS_MORE_LABEL_EXPANDED = "Mostrar menos";

document.addEventListener("DOMContentLoaded", () => {
  document
    .querySelectorAll("[data-soliere-match]")
    .forEach(bindSoliereMatch);

  document
    .querySelectorAll("[data-soliere-match-home]")
    .forEach(initSoliereMatchHome);
});

function msPrefersReducedMotion() {
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

/*------------------------------------------------------
  Expand/collapse — "Continuar descubriendo" / "Mostrar menos"
------------------------------------------------------*/

function bindSoliereMatch(root) {
  const track = root.querySelector("[data-soliere-match-track]");

  bindMatchTrackNav(root);

  const moreBtn = root.querySelector("[data-soliere-match-more]");

  if (!moreBtn || !track) return;

  if (moreBtn.dataset.bound === "true") return;

  moreBtn.dataset.bound = "true";

  const label = moreBtn.querySelector("[data-soliere-match-more-label]");

  moreBtn.addEventListener("click", () => {
    const isExpanded = moreBtn.getAttribute("aria-expanded") === "true";
    const willExpand = !isExpanded;

    moreBtn.setAttribute("aria-expanded", String(willExpand));
    track.classList.toggle("is-expanded", willExpand);

    if (label) {
      label.textContent = willExpand
        ? MS_MORE_LABEL_EXPANDED
        : MS_MORE_LABEL_COLLAPSED;
    }

    if (willExpand) {
      if (typeof track._msUpdateNav === "function") track._msUpdateNav();
    } else {
      // Al colapsar, las secundarias vuelven a display:none — si el
      // track quedó scrolleado hacia ellas, hay que regresarlo al
      // inicio para que las excepcionales sigan visibles.
      track.scrollTo({
        left: 0,
        behavior: msPrefersReducedMotion() ? "auto" : "smooth",
      });

      if (typeof track._msUpdateNav === "function") track._msUpdateNav();
    }
  });
}

/*------------------------------------------------------
  Segunda capa — flechas del track horizontal
------------------------------------------------------*/

function bindMatchTrackNav(root) {
  const track = root.querySelector("[data-soliere-match-track]");
  const prevBtn = root.querySelector("[data-soliere-match-prev]");
  const nextBtn = root.querySelector("[data-soliere-match-next]");

  if (!track || !prevBtn || !nextBtn) return;

  if (track.dataset.navBound === "true") return;

  track.dataset.navBound = "true";

  function scrollTrack(direction) {
    const card = track.querySelector(".maison-product__match-card");
    const gap = parseFloat(getComputedStyle(track).columnGap || "0") || 0;
    const amount = card
      ? card.getBoundingClientRect().width + gap
      : track.clientWidth * 0.8;

    track.scrollBy({
      left: direction * amount,
      behavior: msPrefersReducedMotion() ? "auto" : "smooth",
    });
  }

  function updateNavState() {
    const atStart = track.scrollLeft <= 1;
    const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;

    prevBtn.disabled = atStart;
    nextBtn.disabled = atEnd;
  }

  track._msUpdateNav = updateNavState;

  prevBtn.addEventListener("click", () => scrollTrack(-1));
  nextBtn.addEventListener("click", () => scrollTrack(1));
  track.addEventListener("scroll", updateNavState, { passive: true });
  window.addEventListener("resize", updateNavState);

  updateNavState();
}

/*------------------------------------------------------
  Home — picker → Section Rendering API → resultados
------------------------------------------------------*/

function initSoliereMatchHome(section) {
  const resultsMount = section.querySelector("[data-soliere-match-results]");

  if (!resultsMount) return;

  section.addEventListener("soliere-match:select", (event) => {
    const handle = event.detail && event.detail.handle;

    if (!handle) return;

    renderMatchFor(handle, resultsMount);
  });
}

async function renderMatchFor(handle, resultsMount) {
  resultsMount.setAttribute("aria-busy", "true");
  resultsMount.classList.add("is-loading");
  resultsMount.classList.remove("is-empty", "is-error");

  try {
    const response = await fetch(
      "/products/" +
        encodeURIComponent(handle) +
        "?section_id=soliere-match-render",
    );

    if (!response.ok) {
      throw new Error("HTTP " + response.status);
    }

    const html = await response.text();

    const temp = document.createElement("div");

    temp.innerHTML = html;

    const matchNode = temp.querySelector("[data-soliere-match]");

    if (matchNode) {
      resultsMount.innerHTML = "";
      resultsMount.appendChild(matchNode);
      bindSoliereMatch(resultsMount);
    } else {
      resultsMount.classList.add("is-empty");
      resultsMount.innerHTML =
        '<p class="soliere-match-picker__message ms-lead">' +
        "Aún no tenemos recomendaciones para esta fragancia." +
        "</p>";
    }
  } catch (error) {
    resultsMount.classList.add("is-error");
    resultsMount.innerHTML =
      '<p class="soliere-match-picker__message ms-lead">' +
      "No pudimos cargar las recomendaciones. Intenta de nuevo." +
      "</p>";
  } finally {
    resultsMount.removeAttribute("aria-busy");
    resultsMount.classList.remove("is-loading");
    resultsMount.scrollIntoView({ behavior: "smooth", block: "nearest" });
  }
}
